import { Component, OnInit } from '@angular/core';
import { ConfigService } from '@aiwyn/config';

@Component({
  selector: 'app-login-banner',
  templateUrl: './login-banner.component.html',
  styleUrls: ['./login-banner.component.scss'],
  standalone: false,
})
export class LoginBannerComponent implements OnInit {

  company: string = 'payments';

  constructor(private configService: ConfigService) { }

  ngOnInit(): void {
    this.company = this.configService.customerName
  }

}
